<template>
    <div class="frombanner-box" id="frombanner">
        <h3 class="cpation">{{msg.caption}}</h3>
        <div class="button" @click='upImg'>{{msg.botton}}</div>
        <el-dialog title="立即咨询我们的数字营销专家" :visible.sync="centerDialogVisible" width="60%" center append-to-body class="myFrom" destroy-on-close>
            <From></From>
        </el-dialog>
    </div>
</template>
<script>
     import From from '@/components/base/fromtable'//引入表单
    export default {
        name: 'FromBanner',
        props: {
            msg: Object
        },
        components:{
            From
        },
        data() {
            return {
                centerDialogVisible:false
            }
        },
        methods: {
            upImg(){
                this.centerDialogVisible=true
            }
        }
    }
</script>
<style scoped>
    .frombanner-box {
        height: 600px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/22058393137661.5e5d5bc2cb339.jpg') no-repeat center;
        background-size: cover;
        background-attachment: fixed;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .frombanner-box::after {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(17, 17, 17, .3);
        ;
    }

    .cpation {
        font-size: 40px;
        font-weight: 400;
        line-height: 56px;
        max-width: 660px;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 66px;
        position: relative;
        z-index: 3;
    }

    .button {
        position: relative;
        width: 152px;
        height: 56px;
        background: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 56px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
        z-index: 3;
    }

    .QR {
        display: block;
        height: 400Px;
        width: 400Px;
        margin: 0 auto;
    }
     /* ================================================================表单样式 ========================================================*/
     .myFrom .fromtable>>>.Myfrom{
        padding:0 5%;
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5%;
        grid-template-areas:'Name Company'
                            'Email Tel'
                            'Captiond Captiond'
                            'DemandContent DemandContent'
                            'Submit Submit';
    }
    .fromtable>>>.subMit {
        justify-self: center;
        background-color: #000;
        width: 168px;
        height: 50px;
        border-radius: 30px;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        color: #ffffff;
    }

    .fromtable>>>.el-input__inner{
        border: none;
        border-radius: 0%;
        height: 60px;
        border-bottom: 1px solid #333;
    }
    .fromtable>>>.el-textarea__inner{
        border: 1px solid #333;
    }

    @media(max-width: 995px){
        .frombanner-box {
            height: auto;
            background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/22058393137661.5e5d5bc2cb339.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
            padding:10% 5%;
        }
        .cpation {
            font-size: 24px;
            line-height: 140%;
            max-width: 90%;
            margin-bottom:5%;
        }
        .button {
            max-width: 100px;
            height:auto;
            border-radius: 8px;
            font-size: 16px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/base/frombanner.vue